<template>
  <div class="followorder-account">
    <div class="section">
      <div class="section-title">{{ $t("followOrder.text3") }}</div>
      <div class="section-content mt-20">
        <div class="info-item">
          <div class="info-label">{{ $t("followOrder.text4") }}：</div>
          <div class="info-value">{{ masterInfo.nickName || "--" }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ $t("followOrder.text5") }}：</div>
          <div class="info-value">{{ masterInfo.customerName || "--" }}</div>
        </div>
        <div class="info-item" v-if="agentConfig.phoneLoginReg">
          <div class="info-label">{{ $t("followOrder.text6") }}：</div>
          <div class="info-value">{{ masterInfo.phone || "--" }}</div>
        </div>
        <div class="info-item" v-if="agentConfig.emailLoginReg">
          <div class="info-label">{{ $t("proxy.text34") }}：</div>
          <div class="info-value">{{ masterInfo.email || "--" }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ $t("followOrder.text7") }}：</div>
          <div class="info-value">{{ masterInfo.webAccountName || "--" }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{ $t("followOrder.text8") }}：</div>
          <div class="info-value">{{ masterInfo.isStarDesc || "--" }}</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="section-title">{{ $t("proxy.text14") }}</div>
      <div class="section-content mt-30">
        <div class="data-summary">
          <div
            class="data-card"
            v-for="(label, key) in dataSummaryLabels"
            :key="key"
          >
            <div class="data-value">
              {{
                dataSummary[key] !== null &&
                dataSummary[key] !== undefined &&
                dataSummary[key] !== ""
                  ? dataSummary[key]
                  : "--"
              }}
            </div>
            <div class="data-label">{{ label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import apiService from "@/api/request";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
// 使用 useI18n 获取翻译函数
const { t } = useI18n();
const store = useStore();
const agentConfig = computed(() => store.getters.getAgentConfig);

const masterInfo = ref({
  masterInfo: "",
  customerName: "",
  phone: "",
  email: "",
  webAccountName: "",
  isStarDesc: "",
});

const dataSummary = ref({
  transactionOrders: 0,
  lotSize: 0,
  monthlyAvgOrders: 0,
  buyVsSell: 0,
  winRate: 0,
  sevenDaysProfit: 0,
  thirtyDaysProfit: 0,
  totalProfit: 0,
  maxDrawdown: 0,
  avgOrderDuration: 0,
  currentFollowers: 0,
  totalFollowers: 0,
  avgFollowDuration: 0,
  followersTotalRevenue: 0,
  followFeeThirtyDays: 0,
  followIncome: 0,
  followIncomeBalance: 0,
});

// 创建一个动态的映射，用于获取国际化的键值
const dataSummaryLabels = computed(() => ({
  transactionOrders: t("followOrder.text10"),
  lotSize: t("followOrder.text11"),
  monthlyAvgOrders: t("followOrder.text12"),
  buyVsSell: t("followOrder.text13"),
  winRate: t("followOrder.text14"),
  sevenDaysProfit: t("followOrder.text15"),
  thirtyDaysProfit: t("followOrder.text16"),
  totalProfit: t("followOrder.text17"),
  maxDrawdown: t("followOrder.text18"),
  avgOrderDuration: t("followOrder.text19"),
  currentFollowers: t("followOrder.text21"),
  totalFollowers: t("followOrder.text22"),
  avgFollowDuration: t("followOrder.text23"),
  followersTotalRevenue: t("followOrder.text24"),
  followFeeThirtyDays: t("followOrder.text25"),
  followIncome: t("followOrder.text26"),
  followIncomeBalance: t("followOrder.text27"),
}));

// 请求 master 信息的函数
const fetchMasterInfo = async () => {
  try {
    const response = await apiService.followMasterInfo();
    if (response.status === 1) {
      const data = response.data;
      masterInfo.value = {
        nickName: data.nickName || "--",
        customerName: data.customerName || "--",
        phone: data.phone || "--",
        email: data.email || "--",
        webAccountName: data.webAccountName || "--",
        isStarDesc: data.isStarDesc || "--",
      };
      dataSummary.value = {
        transactionOrders: data.tradeNum || 0,
        lotSize: data.quantity || 0,
        monthlyAvgOrders: data.avgMtlyTradeNum || 0,
        buyVsSell: data.longShortRatio || 0,
        winRate: data.winrateDesc || 0,
        sevenDaysProfit: data.profitSevenDesc || 0,
        thirtyDaysProfit: data.profitThirtyDesc || 0,
        totalProfit: data.profitDesc || 0,
        maxDrawdown: data.maxDrawdownDesc || 0,
        avgOrderDuration: data.avgTimediffDesc || 0,
        currentFollowers: data.followNumNow || 0,
        totalFollowers: data.followNumHis || 0,
        avgFollowDuration: data.avgFollowDaysDesc || 0,
        followersTotalRevenue: data.followUserTotalProfit || 0,
        followFeeThirtyDays: data.price || 0,
        followIncome: data.strategyRevenue || 0,
        followIncomeBalance: data.strategyRevenueBalance || 0,
      };
    } else {
      console.error("获取个人信息失败:", response.message);
    }
  } catch (error) {
    console.error("请求失败:", error);
  }
};

// 组件挂载时请求数据
onMounted(() => {
  fetchMasterInfo();
});
</script>

<style scoped>
.info-item {
  font-family: PingFangSC, PingFang SC;
  display: flex;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 20px;
}
.info-label {
  flex: 0 0 148px;
  width: 148px;
}
.info-value {
  flex: 1 1 auto;
}
.data-summary {
  display: flex;
  flex-wrap: wrap;
  max-width: 1140px;
}
.data-card {
  background: rgba(81, 180, 241, 0.08);
  border-radius: 8px;
  margin-right: 20px;
  margin-bottom: 20px;
  text-align: center;
  width: 170px;
  padding: 16px 0;
}
.data-value {
  font-weight: bolder;
  font-size: 20px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 4px;
}
.data-label {
  font-size: 14px;
  color: #666d7f;
  line-height: 20px;
}
</style>
